// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Ways to Earn Entries`
};

const de_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Möglichkeiten, Einträge zu sammeln`
};

const es_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Formas de Ganar Entradas`
};

const fr_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Moyens de Gagner des Entrées`
};

const fi_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} tapaa kerätä arpoja`
};

const hi_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `एंट्रीज़ कमाने के ${i.count} तरीके`
};

const ja_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} エントリー獲得方法`
};

const nl_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Manieren om deelnames te verdienen`
};

const pt_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Formas de Ganhar Participações`
};

const ro_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Ai ${i.count} modalități de a acumula Puncte.`
};

const th_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} วิธีรับรายการเข้าร่วม`
};

const ur_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} انٹریز جیتنے کے طریقے`
};

const zh_hant1_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} 賺取抽獎機會的方法`
};

const da_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Måder at optjene deltagelser på`
};

const it_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Modi per Guadagnare Partecipazioni`
};

const vn_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Cách Thức Kiếm Lượt Tham Gia`
};

const ko_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} 참여 기회 얻는 방법`
};

const tr_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Katılım Kazanma Yolları`
};

const lv_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Veidi, kā nopelnīt ierakstus`
};

const ar_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} طرق لكسب المشاركات`
};

const bs_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} načina za zarađivanje učešća`
};

const sl_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} načinov za pridobitev vnosov`
};

const id_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Cara untuk Mendapatkan Entri`
};

const sv_widget_ways_to_earn_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} sätt att tjäna deltaganden`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_ways_to_earn_entries = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_ways_to_earn_entries(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_ways_to_earn_entries", locale)
	if (locale === "en") return en_widget_ways_to_earn_entries(inputs)
	if (locale === "de") return de_widget_ways_to_earn_entries(inputs)
	if (locale === "es") return es_widget_ways_to_earn_entries(inputs)
	if (locale === "fr") return fr_widget_ways_to_earn_entries(inputs)
	if (locale === "fi") return fi_widget_ways_to_earn_entries(inputs)
	if (locale === "hi") return hi_widget_ways_to_earn_entries(inputs)
	if (locale === "ja") return ja_widget_ways_to_earn_entries(inputs)
	if (locale === "nl") return nl_widget_ways_to_earn_entries(inputs)
	if (locale === "pt") return pt_widget_ways_to_earn_entries(inputs)
	if (locale === "ro") return ro_widget_ways_to_earn_entries(inputs)
	if (locale === "th") return th_widget_ways_to_earn_entries(inputs)
	if (locale === "ur") return ur_widget_ways_to_earn_entries(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_ways_to_earn_entries(inputs)
	if (locale === "da") return da_widget_ways_to_earn_entries(inputs)
	if (locale === "it") return it_widget_ways_to_earn_entries(inputs)
	if (locale === "vn") return vn_widget_ways_to_earn_entries(inputs)
	if (locale === "ko") return ko_widget_ways_to_earn_entries(inputs)
	if (locale === "tr") return tr_widget_ways_to_earn_entries(inputs)
	if (locale === "lv") return lv_widget_ways_to_earn_entries(inputs)
	if (locale === "ar") return ar_widget_ways_to_earn_entries(inputs)
	if (locale === "bs") return bs_widget_ways_to_earn_entries(inputs)
	if (locale === "sl") return sl_widget_ways_to_earn_entries(inputs)
	if (locale === "id") return id_widget_ways_to_earn_entries(inputs)
	if (locale === "sv") return sv_widget_ways_to_earn_entries(inputs)
	return "widget_ways_to_earn_entries"
};